import {interviewService} from '@jobseeker/common-core/services';
import {Dialog} from '@jobseeker/lotus/components';
import {VersionVariants} from '@jobseeker/lotus/enums';
import {openUrl} from '@jobseeker/common-core/utils/common';
import {Box, Button, Typography} from '@mui/material';
import dayjs from 'dayjs';
import {useState} from 'react';

type PropType = {
  date: Date;
  timing: string;
  calendarId: string;
  slotId: string;
  open: boolean;
  handleSlotTimingConfirmationDialogClose: () => void;
  reschedule: number;
  recruiterId?: number;
};

const SlotTimingConfirmationDialog = (props: PropType) => {
  const {
    date,
    calendarId,
    slotId,
    timing,
    open,
    handleSlotTimingConfirmationDialogClose,
    reschedule,
    recruiterId = 0,
  } = props;
  const [loading, setLoading] = useState(false);
  const handleSlotConfirmation = async () => {
    setLoading(true);
    await interviewService.confirmInterview({
      calendarId,
      slotId,
      dateSlot: dayjs(date).format('YYYY-MM-DD').toString(),
      timeSlot: timing,
      reschedule,
      recruiterId,
    });

    if (reschedule === 1) {
      openUrl(`${process.env.NEXT_PUBLIC_LOAD_CONFIG}/interviews`, '_self');
    } else {
      window.location.reload();
    }
  };

  return (
    <Dialog
      variant={VersionVariants.VERSION_THREE}
      open={open}
      title=""
      titleProps={{
        height: 34,
      }}
      onClose={handleSlotTimingConfirmationDialogClose}
      sx={{
        '& .MuiPaper-root': {
          maxWidth: {xs: 350, md: 372},
          borderRadius: '8px',
          textAlign: 'center',
          height: {xs: 290, md: 275},
        },
        '& .MuiDialogContent-root': {
          px: 4.375,
          pb: 5,
        },
        '& .MuiIconButton-root': {
          ':hover': {
            bgcolor: 'transparent',
          },
        },
      }}
    >
      <Typography component="h1" fontSize={18} textAlign="left">
        Available Start Timings{' '}
        <Typography component="span" fontWeight={700} fontSize={18}>
          ({dayjs(date).format('DD MMM YYYY')})
        </Typography>
      </Typography>
      <Box
        sx={{
          border: '1px solid #C8EFD5',
          borderRadius: 0.625,
          bgcolor: '#e8fff0',
          color: '#2bae65',
          fontSize: 13,
          fontWeight: 700,
          width: '100%',
          ':hover': {
            bgcolor: '#e8fff0',
          },
          height: 58,
          mt: 3.75,
          mb: 3,
          py: 2.7,
        }}
      >
        {timing}
      </Box>
      <Button
        variant="contained"
        sx={{
          borderRadius: 0.625,
          fontSize: 16,
          fontWeight: 500,
          py: 1.5,
          width: '100%',
          height: 48,
        }}
        onClick={handleSlotConfirmation}
        disabled={loading}
      >
        Confirm
      </Button>
    </Dialog>
  );
};

export default SlotTimingConfirmationDialog;
